import { render } from "./UploadIllustration.vue?vue&type=template&id=c9c95f1e"
import script from "./UploadIllustration.vue?vue&type=script&lang=js"
export * from "./UploadIllustration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__